import { render, staticRenderFns } from "./ZiXunDetail.vue?vue&type=template&id=5c9d26a9&scoped=true&"
import script from "./ZiXunDetail.vue?vue&type=script&lang=js&"
export * from "./ZiXunDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d26a9",
  null
  
)

export default component.exports